<template>
<div class="mb-0 border-0">
    <div class="card-body text-center py-3 mb-3">
        <div class="mt-3 mb-3">
            <img src="@/assets/global_assets/images/limit-store.png" class="" alt="" width="300px">
        </div>
        <h1 class="error-page-title">{{$t(title)}}</h1>
        <div class="error-page-text">
            <div>{{$t(detail)}}</div>
            <div>{{$t('If you want to increase the number of stores Please contact sales to consider adding a store.')}}</div>
        </div>
        <div class="mt-4">
            <button class="btn btn-lg btn-primary" @click="closeModal" ><i class="fas fa-thumbs-up"></i> {{$t('OK')}}</button>
        </div>
    </div>
</div>
</template>
<script>
export default {
    components: {},
    data() {
        return {

        }
    },
    
    props: ['title','detail'],
    async mounted() {
        
    },
    methods: {
      closeModal() {
          this.$parent.$refs.close.click();
          this.$parent.checkClick = true;
      }
    }

};
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/error-page/templates/StoreLimit.vue